const Colors: React.FC = () => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <h1>Farben</h1>
          <p className="lead">
            Nachfolgend finden Sie die nutzbaren Primär- und Sekundärfarben.
          </p>
        </div>
        <div className="col-12">
          <h2>Primäre Farbpalette</h2>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-primary text-white modal-lg d-flex justify-content-between align-content-center">
            <span>Primary</span>
            <span className="badge bg-light text-black">#000000</span>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-secondary text-black modal-lg d-flex justify-content-between align-content-center">
            <span>Secondary</span>
            <span className="badge bg-light text-black">#fde703</span>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-white border text-black modal-lg d-flex justify-content-between align-content-center">
            <span>White</span>
            <span className="badge bg-white text-black">#ffffff</span>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <h2>Sekundäre Farbpalette</h2>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-danger text-white modal-lg d-flex justify-content-between align-content-center">
            <span>Danger</span>
            <span className="badge bg-light text-black">#df305b</span>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-success text-white modal-lg d-flex justify-content-between align-content-center">
            <span>Success</span>
            <span className="badge bg-light text-black">#198754</span>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-warning text-dark modal-lg d-flex justify-content-between align-content-center">
            <span>Warning</span>
            <span className="badge bg-light text-black">#ffc107</span>
          </div>
        </div>
        <div className="col-md-4">
          <div className="p-3 mb-3 bg-info text-dark modal-lg d-flex justify-content-between align-content-center">
            <span>Info</span>
            <span className="badge bg-light text-black">#dee2e6</span>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-3 mb-3 bg-light text-dark modal-lg d-flex justify-content-between align-content-center">
            <span>Light</span>
            <span className="badge bg-black text-white">#f1f1ee</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Colors;
